import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

import sportsImage from "../../../assets/images/deportesFondo.jpg";
import artImage from "../../../assets/images/arte3.jpg";
import "./ActivitiesLanding.css";

const ACTIVITIES = [
  {
    eyebrow: "Educación física",
    title: "Deportes",
    text: "Vóley, básquet, handball y fútbol, campamentos y vida en la naturaleza. El cuerpo en movimiento como parte esencial de la formación.",
    image: sportsImage,
    to: "/deportes",
  },
  {
    eyebrow: "Plástica · música · teatro",
    title: "Arte",
    text: "Talleres de artes visuales, música y teatro que culminan cada año en muestras y encuentros para las familias.",
    image: artImage,
    to: "/arteActividad",
  },
];

export default function ActivitiesLanding() {
  return (
    <>
      <main className="tc-activities-page">
        <div className="tc-activities-container">
          <motion.header
            className="tc-activities-heading"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span>Actividades</span>
            <h1>Deportes y Arte</h1>
            <div />
          </motion.header>

          <section className="tc-activities-grid" aria-label="Propuestas de actividades">
            {ACTIVITIES.map((activity, index) => (
              <motion.article
                key={activity.title}
                className="tc-activity-feature"
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.12 }}
              >
                <img src={activity.image} alt={activity.title} />
                <div className="tc-activity-feature-shade" />
                <div className="tc-activity-feature-copy">
                  <span>{activity.eyebrow}</span>
                  <h2>{activity.title}</h2>
                  <p>{activity.text}</p>
                  <Link to={activity.to}>Conocer más <FaArrowRight /></Link>
                </div>
              </motion.article>
            ))}
          </section>
        </div>
      </main>
    </>
  );
}
